import React from 'react';
import { useHistory } from 'react-router-dom';

export const useScrollToTop = () => {
  const history = useHistory();
  const prevLocation = React.useRef({ ...history.location });

  React.useEffect(() => {
    return history.listen((location, action) => {
      if (!['PUSH', 'REPLACE'].includes(action)) {
        return;
      }

      if (location.pathname !== prevLocation.current.pathname) {
        window.scrollTo(0, 0);
      }

      prevLocation.current = { ...location };
    });
  }, [history]);
};
